const message = {
    defaultTitle: "KneUnion", indexLabel: "Home", overflowedIndicator: "More"
};

export default message;